import React from "react";
import {Typography} from "antd";

const {Text} = Typography;

interface DashboardScheduleValueProps {
    label: string;
    value: React.ReactNode;
    highlighted?: boolean;
}

export const DashboardScheduleValue: React.FC<DashboardScheduleValueProps> = ({
    label,
    value,
    highlighted = false,
}) => (
    <div className={"health-center-dashboard__schedule-value" + (highlighted ? " health-center-dashboard__schedule-value--highlighted" : "")}>
        <Text type="secondary">{label}</Text>
        <Text strong={highlighted}>{value}</Text>
    </div>
);
